import SuperAdminRoute from "app/routes/SuperAdminRoute";
import SuperAdminAppList from "./SuperAdminAppList";
import SuperAdminTenantList from "./SuperAdminTenantList";
import Page from "@jumbo/shared/Page";

const superAdminRoutes = [
{
    path: "/superadmin/apps",
    element: <SuperAdminRoute element={<Page component={SuperAdminAppList}/>} />
},
{
    path: "/superadmin/tenants",
    element: <SuperAdminRoute element={<Page component={SuperAdminTenantList}/>} />
}
]

export default superAdminRoutes;